import styled from 'styled-components'

export const Page = styled.main`
    width: 100%;
    max-width: 1560px;
    margin: 0 auto;
    padding: 100px clamp(18px, 2.4vw, 36px) 56px;
    animation: competitiveIntelligenceReveal 0.42s ease both;
    @keyframes competitiveIntelligenceReveal { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }
    @media (prefers-reduced-motion: reduce) { animation: none; }
`;
